import { useMutation, useQueryClient } from '@tanstack/react-query';

import { engagementResourcesService } from '../services';
import type { UpdateResourceInput } from '../types';

import { engagementResourcesKeys } from './useEngagementResources';

export function useUpdateResource(id: string) {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (input: UpdateResourceInput) => engagementResourcesService.update(id, input),
    onSuccess: (resource) => {
      void qc.invalidateQueries({ queryKey: engagementResourcesKeys.lists() });
      qc.setQueryData(engagementResourcesKeys.detail(id), resource);
    },
  });
}
